import axios from 'axios';
const URL = 'https://api.bybit.com';
class ByBit {
    constructor() {
        console.log('bybit');
    }
    static async GetSymbols() {
        const url = URL + '/v5/market/tickers?category=linear';
        try {
            const request = await axios.get(url);
            const data = request.data;
            if (data.retCode == 0) {
                return data.result.list.map((x) => x.symbol);
            }
            return [];
        }
        catch (error) {
            console.log('error in request', error);
        }
    }
}
export default ByBit;
